import React from "react";
import "./Campaign.scss";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const MarchSchoolHolidayCampaign = () => {
  return (
    <>
      <Navbar />

      <div className="privacy-and-terms">
        <div className="container">

          {/* HEADER */}
          <div className="header-title giftaway-header">
            <div className="overlay">
              <h2>Teleport March School Holidays Campaign Terms & Conditions</h2>
            </div>
          </div>

          {/* CONTENT */}
          <div className="page-content">

            <div className="term-heading">
              <h4>March School Holidays Campaign Terms & Conditions</h4>
              <p>
                Campaign Period:{" "}
                <span>12 March 2026 – 31 March 2026 (SGT)</span>
              </p>
            </div>

            <div className="point-wrap">

              {/* INTRODUCTION */}
              <h2>1. Introduction</h2>
              <p>
                The following Terms and Conditions govern the participation in the
                <b> March School Holidays Campaign </b> (“Campaign”) organised by{" "}
                <b>Teleport Now (SG) Pte. Ltd.</b> (“Teleport Now”, “we”, “our”, or “us”),
                a company incorporated in Singapore.
              </p>

              <p>
                By participating in this Campaign, users acknowledge that they
                have read, understood, and agreed to be bound by these Terms and
                Conditions.
              </p>

              <hr />

              {/* CAMPAIGN PERIOD */}
              <h2>2. Campaign Period</h2>

              <p>
                The Campaign will run from <b>12 March 2026, 00:00 hours</b> to{" "}
                <b>31 March 2026, 23:59 hours (Singapore Time)</b>.
              </p>

              <p>
                Only users who successfully create a new Teleport Now account
                within the Campaign Period will be eligible for the Campaign
                reward.
              </p>

              <p>
                Registrations completed outside the Campaign Period will not
                qualify for the Campaign reward.
              </p>

              <hr />

              {/* ELIGIBILITY */}
              <h2>3. Campaign Eligibility</h2>

              <p>To qualify for the Campaign reward, users must satisfy ALL of the following conditions:</p>

              <ul>
                <li>
                  Create a <b>new Teleport Now account</b> during the Campaign Period.
                </li>

                <li>
                  Complete the required account verification process,
                  including verification via <b>email or mobile number</b>.
                </li>

                <li>
                  Each individual user is eligible to receive the Campaign reward
                  <b> once only</b>.
                </li>
              </ul>

              <p>
                Users who created a Teleport Now account prior to the Campaign
                Period shall <b>not</b> be eligible to receive the Campaign reward.
              </p>

              <hr />

              {/* CAMPAIGN REWARD */}
              <h2>4. Campaign Reward</h2>

              <p>
                Eligible users will receive <b>USD $3 worth of Telly Credits</b>
                upon successful account registration and verification during the
                Campaign Period.
              </p>

              <ul>
                <li>
                  Telly Credits will be credited to the user’s Teleport Now account
                  within <b>two (2) working days</b> after successful registration.
                </li>

                <li>
                  Teleport Now shall not be responsible for delays caused by
                  technical issues, verification failures, or system errors.
                </li>
              </ul>

              <hr />

              {/* USE OF TELLY CREDITS */}
              <h2>5. Use of Telly Credits</h2>

              <p>
                Telly Credits issued under this Campaign may be used within the
                Teleport Now platform for eligible purchases including:
              </p>

              <ul>
                <li>Flight bookings</li>
                <li>Travel eSIM purchases</li>
              </ul>

              <p>Telly Credits:</p>

              <ul>
                <li>are non-transferable</li>
                <li>cannot be exchanged for cash</li>
                <li>cannot be withdrawn</li>
                <li>cannot be resold or transferred to another user</li>
              </ul>

              <p>
                Teleport Now reserves the sole and absolute discretion to
                determine the eligibility of purchases that qualify for the use
                of Telly Credits.
              </p>

              <hr />

              {/* VALIDITY */}
              <h2>6. Validity of Telly Credits</h2>

              <p>
                Telly Credits issued under this Campaign are valid for a period
                of <b>six (6) months</b> from the date of issuance.
              </p>

              <p>
                Any unused Telly Credits will automatically expire after the
                validity period and will not be reinstated, refunded, or
                extended under any circumstances.
              </p>

              <hr />

              {/* REFERRAL */}
              <h2>7. Interaction with Referral Promotion</h2>

              <p>
                This Campaign may run concurrently with Teleport Now’s referral
                programme.
              </p>

              <p>
                Users who participate in both the Campaign and the referral
                programme may receive additional Telly Credits in accordance
                with the applicable referral programme terms and conditions.
              </p>

              <hr />

              {/* ABUSE */}
              <h2>8. Abuse and Misuse</h2>

              <p>
                Teleport Now reserves the right to disqualify any participant and
                revoke any Telly Credits granted if there is reasonable suspicion
                of fraud, abuse, or misuse of the Campaign.
              </p>

              <p>This includes, but is not limited to:</p>

              <ul>
                <li>Creation of multiple accounts by the same individual</li>
                <li>Use of false, misleading, or fabricated information</li>
                <li>Manipulation or abuse of the Campaign mechanics</li>
                <li>Use of automated systems, bots, or scripts to create accounts</li>
              </ul>

              <p>
                Teleport Now reserves the right to cancel, reverse, or deduct any
                Telly Credits that were issued as a result of such activities.
              </p>

              <hr />

              {/* MODIFICATION */}
              <h2>9. Modification or Termination</h2>

              <p>
                Teleport Now reserves the right to modify, suspend, or terminate
                the Campaign at any time without prior notice if required due to
                operational, legal, technical, or regulatory reasons.
              </p>

              <p>
                Where practicable, updates or changes will be communicated
                through Teleport Now’s official channels.
              </p>

              <hr />

              {/* FINAL DECISION */}
              <h2>10. Final Decision</h2>

              <p>
                Teleport Now’s decision on all matters relating to the Campaign,
                including eligibility and reward issuance, shall be final and
                binding on all participants.
              </p>

              <hr />

              {/* GOVERNING LAW */}
              <h2>11. Governing Law</h2>

              <p>
                These Terms and Conditions shall be governed by and interpreted
                in accordance with the laws of Singapore.
              </p>

              <hr />

              {/* CONTACT */}
              <h2>Contact Information</h2>

              <p>
                TELEPORT NOW (SG) PTE. LTD. <br />
                Email: support@teleportapp.sg
              </p>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default MarchSchoolHolidayCampaign;
